import tableVTProviders from './tableVTProviders';

export default {
  title: 'Virtual Ticket Providers',
  attributeName: 'vtproviders',
  getURL: 'organization/organizationId/agreements/vtproviders',
  createURL: '',
  updateURL: '',
  removeURL: '',
  idAttribute: 'id',
  itemName: 'fullName',
  itemId: 'id',
  sessionParams: ['organizationId'],
  tableConfig: tableVTProviders,
};
